import FullEventDecider from "../screens/Event/FullEventDecider";
import { Route, Routes } from "react-router-dom";
import { memo } from "react";
import DisplayQRCode from "../screens/Event/DisplayQRCode";
import FullEventConfirmation from "../screens/Event/FullEventConfirmation";
import { CreateEvent } from "../screens/CreateEvent/CreateEvent";
import CreateExternalLink from "../screens/CreateEvent/CreateExternalLink";
import ProductDashboardDecider from "../screens/Products/ProductDashboardDecider";
import CreatePost from "../screens/Products/Create/CreatePost";
import CreateProduct from "../screens/Products/Create/CreateProduct";

const EventRoute = memo(function EventRouteFn() {
  return (
    <Routes>
      <Route index element={<FullEventDecider />} />
      <Route path="i">
        <Route index element={<FullEventConfirmation />} />
        <Route path=":userId" element={<FullEventConfirmation />} />
        <Route path=":userId/myTicket" element={<DisplayQRCode />} />
      </Route>
      <Route path="dashboard" element={<ProductDashboardDecider />} />
      <Route path="edit" element={<CreateEvent />} />
      <Route path="edit-post" element={<CreatePost />} />
      {["video", "audio", "pdf", "custom-product"].map((path) => (
        <Route key={path} path={`edit-${path}`} element={<CreateProduct />} />
      ))}
      <Route path="editLink" element={<CreateExternalLink />} />
    </Routes>
  );
});

export default EventRoute;
